import React from "react";
import {Button} from "antd";
import {EyeOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {ResponsiveDataTable} from "components/_defaultComponents/ResponsiveDataTable";
import {TicketStatusTag} from "../common/TicketStatusTag";
import {TicketElapsedTime} from "../common/TicketElapsedTime";
import {formatDate, formatDateTime, formatTime} from "../common/ticketUtils";

export const CustomerTicketsTable = ({
    rows,
    total,
    loading,
    pagination,
    paginated,
    onView,
    onPageChange
}) => {
    const {t} = useTranslation(["tickets"]);
    const label = key => t(`list.columns.${key}`, {ns: "tickets"});
    const cell = key => () => ({"data-label": label(key)});

    const columns = [
        {
            title: label("number"),
            dataIndex: "number",
            key: "number",
            render: number => <strong>{number}</strong>,
            onCell: cell("number")
        },
        {
            title: label("date"),
            key: "date",
            render: (_, record) => (
                <>
                    <div>{formatDate(record.createdAt)}</div>
                    <div>{formatTime(record.createdAt)}</div>
                </>
            ),
            onCell: cell("date")
        },
        {
            title: label("title"),
            key: "title",
            render: (_, record) => record.ticketType?.name || "-",
            onCell: cell("title")
        },
        {
            title: label("lastAction"),
            key: "lastAction",
            render: (_, record) => formatDateTime(record.updatedAt || record.createdAt),
            onCell: cell("lastAction")
        },
        {
            title: label("status"),
            dataIndex: "status",
            key: "status",
            render: status => <TicketStatusTag status={status} />,
            onCell: cell("status")
        },
        {
            title: label("elapsed"),
            key: "elapsed",
            render: (_, record) => <TicketElapsedTime ticket={record} />,
            onCell: cell("elapsed")
        },
        {
            title: label("action"),
            key: "action",
            render: (_, record) => (
                <Button
                    type="link"
                    size="small"
                    icon={<EyeOutlined />}
                    onClick={() => onView(record)}
                >
                    {t("list.view", {ns: "tickets"})}
                </Button>
            ),
            onCell: cell("action")
        }
    ];

    return (
        <ResponsiveDataTable
            size="small"
            columns={columns}
            dataSource={rows}
            rowKey="_id"
            loading={loading}
            scroll={{x: "max-content"}}
            locale={{emptyText: t("list.empty", {ns: "tickets"})}}
            pagination={
                paginated && {
                    hideOnSinglePage: true,
                    current: Math.floor(pagination.skip / pagination.limit) + 1,
                    pageSize: pagination.limit,
                    total,
                    showTotal: count => t("list.total", {ns: "tickets", total: count}),
                    onChange: onPageChange
                }
            }
        />
    );
};
